import styled from "styled-components";

export const Wrap = styled.div`
  height: 100vh;
  // background-color: black;
  display: grid;
  grid-template-columns: 45% 55%;

  img {
    max-width: 100%;
  }
.header__title{
    font-size: 2rem;
}
  .description{
      width: 75%;
      font-size: 20px;
  }
  .contact__form{
    // margin-left: 3rem;
  }
  .form__nav {

    // padding-top: 24px;
      display: grid;
  grid-template-columns: 40% 8% 1fr;
    border-bottom: 1px solid #E7E3E3;
    // border: 10px solid red;
    margin-right: 3rem;
    
  }
 .form__nav span {
       padding-left: 3rem;
  //  border: 5px solid red;
   margin-top: -1.4rem;
      padding-top 1rem;
   cursor: pointer;
     font-size: 20px;
     font-weight: 700;
   }
   .step{
     
   }
   .form__nav span:nth-of-type(2){
     border-right: 1px solid #E7E3E3;
     width: 10px;
     color: blue;
   }
    .step {
    // font-size: 18px;
    // margin-right: 72px;
    // cursor: pointer;
  }
  .activeStep {
    color:#1269FF;
    padding-top 1rem;
    padding-bottom: 1rem;
    border-bottom: 1px solid #1269FF;
    margin-right: 3rem;
    width: 103.5%;
  }
  .form__nav a:nth-of-type(1){
      // border: 5px solid red;
    }
.contact__form h1{
  padding-left: 3rem;
  border-bottom: 1px solid #E7E3E3;
  margin-right: 3rem;
   font-family: Futura;
   font-weight: 100;
   color: #1B20E5;
   font-size: 2rem;
   margin-top: 5.5rem;
  //  border: 10px solid teal;
}
.footer__session {
  display: none;
}
  @media screen and (max-width: 991px) {
    grid-template-columns: 1fr;
    .contact__form {
      // border: 5px solid red;
      // display: none;
    }
    .description{
      width: 85%;
      font-size: 20px;
  }
     .form__nav {
      display: grid;
  grid-template-columns: 1fr% 7% 1fr;
    border-bottom: 1px solid #E7E3E3;
    // border: 10px solid red;
    margin-right: 3rem;
    
  }
   .form__nav span {
       padding-left: 3rem;
  //  border: 5px solid red;
   margin-top: -1.4rem;
      padding-top 1rem;
   cursor: pointer;
     font-size: 1rem;
     font-weight: 700;
   }
    .footer__session{
      margin-top: 57px;
      display: block;
    }
    
    .contact__form h1{
 padding-left: 1rem;
  border-bottom: 1px solid #E7E3E3;
  margin-right: 1rem;
   font-family: Futura;
   font-weight: 100;
   color: #1B20E5;
   font-size: 2rem;
   margin-top: 5.5rem;
   width: 80%;
   line-height: 2.5rem;
   padding-bottom: 1rem;
  //  border: 10px solid red;
}
     .activeStep {
    color:#1269FF;
    padding-top 1rem;
    padding-bottom: 1rem;
    border-bottom: 1px solid #1269FF;
    margin-right: 1rem;
    // width: 90%;
  }
  }
  @media screen and (max-width: 579px) {
    .contact__form h1{
      margin-top: 3rem;
       margin-left: 1rem;
      text-align: left:
    }
  }
`;

export const SideMessage = styled.div`
  padding-left: 5rem;
  // max-width: 720px;
  color: ${({ theme }) => theme.colors.text};
  padding-top: 1rem;
  padding-bottom: 37px;

  background-image: url("https://res.cloudinary.com/dvwbbiu0g/image/upload/v1651531019/invest-trust/section_b_fftu3z.svg");
  background-repeat: no-repeat;
  background-size: cover;
  //   background-position: right;
  h1 {
    margin-top: 87px;
    font-size: 3rem;
    line-height: 56px;
    max-width: 70%;
    font-family: "Futura";
  }

  div .menu__icon {
    display: none;
  }

  div:nth-of-type(1) {
    // border: 10px solid orange;
  }

  @media screen and (max-width: 991px) {
    padding-bottom: 6rem;
    div .menu__icon {
      display: inline-block;
      margin-right: 1rem;
    }
    div .contact__menu {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .footer__details {
      display: none;
    }
  }
  @media screen and (max-width: 579px) {
    padding-left: 2rem;
    padding-right: 2rem;
    div .menu__icon {
      margin-right: 0rem;
    }
    h1 {
      margin-top: 24px;
      font-size: 2.6rem;
      line-height: 56px;
      max-width: 100%;
    }
  }
`;

export const ContactNav = styled.div`
  margin-top: 2rem;
  padding-right: 5rem;
  display: flex;
  justify-content: flex-end;
  div a {
    margin-right: 2rem;
    color: ${({ theme }) => theme.colors.primary};
  }
  div .active {
    border-bottom: 3px solid ${({ theme }) => theme.colors.secondary};
    padding: 8px 0px;
  }
  @media screen and (max-width: 991px) {
    div {
      display: none;
    }
  }
  @media screen and (max-width: 579px) {
  }
`;

export const ContactHeader = styled.div`
  font-family: Futura;
  color: #1B20E5;
  font-size: 3rem,
  margin-top: 5.5rem
  margin-left: 114px;
`;

export const BurgerNav = styled.div`
  display: none;
  @media screen and (max-width: 991px) {
    // border: 10px solid red;
    padding-top: 2rem;
    display: flex;
    flex-direction: column;
    background-color: ${(props) =>
      props.mode === "dark" ? "#232323" : "#fff"};
    width: 100%;
    height: 100vh;
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    z-index: 1;
    box-shadow: 8px 16px 16px hsl(0deg 0% 0% / 0.25);
    border: 3px solid transparent;
    transform: ${(props) =>
      props.show ? "translateX(0)" : "translateX(100%)"};
    transition: transform 0.2s;
    .active {
      // border-bottom: 3px solid ${({ theme }) => theme.colors.secondary};
      font-weight: bold;
    }
    div:nth-of-type(2) {
      background-image: url("https://res.cloudinary.com/dvwbbiu0g/image/upload/v1652353267/invest-trust/blue_Opaque_shield_logo_lgommu.png");
      display: flex;
      flex-direction: column;
      margin-left: 1rem;
      margin-right: 1rem;
    }

    a {
      margin-left: 2rem;
      margin-right: 2rem;
      padding-top: 2.5rem;
      padding-bottom: 2.5rem;
      color: #000;
      font-size: 18px;
      width: 60%;
    }
  }
`;

export const CustomNav = styled.div`
  display: none;
  @media screen and (max-width: 991px) {
    // border: 10px solid red;
    display: inline-block;
    cursor: pointer;
    margin-top: 0.5rem;
  }
`;
export const CustomClose = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-right: 2rem;
  margin-left: 1rem;
  cursor: pointer;
  z-index: 1;
`;
export const BurgerLogo = styled.div`
  transform: translateY(-3.3rem);
  margin-left: -1rem;
`;

export const SocialMediaIcon = styled.div`
  margin: 60% auto 0 auto;
  width: 40%;
  a {
    margin-right: 2.5rem;
  }
`;
